import { Anstellungstyp } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/anstellungstyp';
import { Mitarbeiter_Anstellungstyp } from '@/gql/graphql';

export function mapAnstellungstyp(
  val: Anstellungstyp | null,
): Mitarbeiter_Anstellungstyp | null {
  if (val === null) {
    return null;
  }
  const anstellungstypen = Object.values(Mitarbeiter_Anstellungstyp);

  for (const a of anstellungstypen) {
    if (a === val) {
      return a;
    }
  }
  throw new Error(`Value ${val} not supported in Anstellungstypen`);
}
